import { FlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const LeftSideContainer = styled(FlexDiv)`
    justify-content: center;
    align-items: center;
    gap: 8px;
`